var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[(_vm.person === 'woman')?_c('img',{attrs:{"data-src":"./assets/parachuter-woman-mid.png"}}):_vm._e(),(_vm.person === 'man')?_c('img',{attrs:{"data-src":"./assets/parachuter-man-mid.png"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }